

module.exports = __webpack_require__.stylable.create(
    "WhiteBackground2802829362",
    {"classes":{"root":"WhiteBackground2802829362__root","WhiteBackground":"WhiteBackground2802829362__WhiteBackground"},"vars":{},"stVars":{"EventCornerRadius":"'\"unit(fallback(--eventCornerRadius, 0), px)\"'","BackgroundColor":"\"fallback(color(--calendarBackgroundColor), fallback(color(--bgBoxColor), color(color-1)))\""},"keyframes":{}},
    "",
    1,
    "WhiteBackground2802829362",
    null
);
